"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataMockDiffs = exports.getDataMockSuites = void 0;
const academia_webp_1 = __importDefault(require("../../../assets/images/academia.webp"));
const ar_condicionado_webp_1 = __importDefault(require("../../../assets/images/ar-condicionado.webp"));
const cozinha_webp_1 = __importDefault(require("../../../assets/images/cozinha.webp"));
const lavanderia_webp_1 = __importDefault(require("../../../assets/images/lavanderia.webp"));
const lazer_webp_1 = __importDefault(require("../../../assets/images/lazer.webp"));
const localizacao_webp_1 = __importDefault(require("../../../assets/images/localizacao.webp"));
const piscina_webp_1 = __importDefault(require("../../../assets/images/piscina.webp"));
const portaria_webp_1 = __importDefault(require("../../../assets/images/portaria.webp"));
const suite_wifi_webp_1 = __importDefault(require("../../../assets/images/suite_wifi.webp"));
const varanda_webp_1 = __importDefault(require("../../../assets/images/varanda.webp"));
const tv_moveis_webp_1 = __importDefault(require("../../../assets/images/tv_moveis.webp"));
const seguranca_webp_1 = __importDefault(require("../../../assets/images/seguranca.webp"));
const suites = [
    {
        imgUrl: suite_wifi_webp_1.default,
        text: 'Suítes com WI-FI',
    },
    {
        imgUrl: varanda_webp_1.default,
        text: 'Varanda',
    },
    {
        imgUrl: ar_condicionado_webp_1.default,
        text: 'Ar Condicionado',
    },
    {
        imgUrl: tv_moveis_webp_1.default,
        text: 'Tv e Móveis',
    },
    {
        imgUrl: cozinha_webp_1.default,
        text: 'Cozinha Compacta',
    },
    {
        imgUrl: seguranca_webp_1.default,
        text: 'Segurança',
    },
];
const condominiums = [
    {
        imgUrl: localizacao_webp_1.default,
        text: 'Localização Privilegiada',
    },
    {
        imgUrl: portaria_webp_1.default,
        text: 'Portaria 24H',
    },
    {
        imgUrl: lavanderia_webp_1.default,
        text: 'Lavanderia',
    },
    {
        imgUrl: piscina_webp_1.default,
        text: 'Piscina',
    },
    {
        imgUrl: academia_webp_1.default,
        text: 'Academia',
    },
    {
        imgUrl: lazer_webp_1.default,
        text: 'Áreas de lazer',
    },
];
const getDataMockSuites = () => new Promise(resolve => resolve(suites));
exports.getDataMockSuites = getDataMockSuites;
const getDataMockDiffs = () => new Promise(resolve => resolve(condominiums));
exports.getDataMockDiffs = getDataMockDiffs;
